import {combineReducers} from 'redux';

import settingReducer from "./shared/reducers/setting"
import moduleReducer from './shared/reducers/modules'
import reportListReducer from './reducers/report'
import farmListReducer from "./reducers/farm"
import plotListReducer from "./reducers/plot"
import departmentReducer from "./reducers/department"
import machineReducer from "./reducers/machine"
import sensorReducer from "./reducers/sensor"

import {routerReducer} from 'react-router-redux';


const reducers = combineReducers({
  routing: routerReducer,
  farmList: farmListReducer,
  reportList: reportListReducer,
  selectedPlot:plotListReducer,
  bottomReached:plotListReducer,
  plotList:plotListReducer,
  plotMqtt:plotListReducer,
  sensor:sensorReducer,
  setting: settingReducer,
  department: departmentReducer,
  machine: machineReducer,
  report: reportListReducer,
  modules:moduleReducer
});

export default reducers;
